<div class="tabs" [attr.id]="id ? id + '-header' : null">
  @for (tab of tabs; track tab; let i = $index) {
    <button
      [attr.id]="id ? id + '-tab-' + i : null"
      (click)="selectTab(i)"
      [class.active]="selectedTabIndex === i"
      >
      {{ tab.label }}
    </button>
  }
</div>

@if (tabs.length) {
  <div class="tab-content-wrapper" [attr.id]="id ? id + '-content-container' : null">
    <ng-container *ngTemplateOutlet="tabs[selectedTabIndex].component; context: tabs[selectedTabIndex].context">
    </ng-container>
  </div>
}
